<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";

import FeedbackBlock from "@js/components/Sections/Feedbacks/Components/FeedbackBlock.vue";
import {Link} from "@inertiajs/vue3";
import IconComment from "@js/components/Icons/IconComment.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "Feedbacks",
    components: {
        IconAngleLeft,
        OnlyDesktop, OnlyMobile, IconComment, Link, FeedbackBlock, Swiper, SwiperSlide
    },
    data() {
        return {
            slider_breakpoints: {
                640: {slidesPerView: 1.2, spaceBetween: 10},
                768: {slidesPerView: 1.5, spaceBetween: 20},
                1024: {slidesPerView: 2.5, spaceBetween: 20}
            },
            text_feedbacks: [
                {
                    name: 'Андрей Кузнецов',
                    text: 'Заказывали ЖБИ для стройки. Нужно было быстро привезти плиты, чтобы не тормозить работы. Ребята помогли с выбором, объяснили что лучше взять под нашу задачу. Доставку согласовали заранее, все приехало вовремя. По качеству все нормально - плиты ровные, без явных косяков.',
                    link: '',
                    date_formatted: '18 Марта 2026',
                    date: '2026-03-18',
                },
                {
                    name: 'Sergey Volkov',
                    text: 'Берем здесь бетон и нерудные материалы под объекты. Главное для нас - сроки, чтобы техника не стояла. Поставки приходят как договаривались, без срывов. Объемы совпадают, по документам тоже все ок. Удобно работать, без лишней суеты.',
                    link: '',
                    date_formatted: '02 Апреля 2026',
                    date: '2026-04-02',
                },
                {
                    name: 'Илья Морозов',
                    text: 'Искали поставщика, чтобы закрыть сразу несколько позиций - ЖБИ, пиломатериалы и плитку. Тут получилось все взять в одном месте, что сильно упростило процесс. Помогли посчитать объемы, быстро оформили заказ. Все приехало как обсуждали, без неприятных сюрпризов.',
                    link: '',
                    date_formatted: '25 Февраля 2026',
                    date: '2026-02-25',
                },
                {
                    name: 'Михаил Я.',
                    text: 'Заказывали тротуарную плитку и конструкции для благоустройства. Быстро ответили, сказали что есть в наличии и какие сроки. Подстроились под наш график по доставке. Привезли аккуратно, без повреждений. В целом нормальный поставщик - можно работать.',
                    link: '',
                    date_formatted: '11 Января 2026',
                    date: '2026-01-11',
                },
            ],
            swiper: null,
        };
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
        insertSchemaMarkup() {
            if (checkDocument()) {
                const scriptId = "schema-reviews-jsonld"
                let script = document.getElementById(scriptId)

                if (script) {
                    script.remove()
                }

                script = document.createElement("script")
                script.id = scriptId
                script.type = "application/ld+json"
                script.textContent = JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": this.text_feedbacks.map((feedback, index) => ({
                        "@type": "Review",
                        "author": {
                            "@type": "Person",
                            "name": feedback.name
                        },
                        "datePublished": feedback.date,
                        "reviewBody": feedback.text,
                        "url": feedback.link,
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": 5,
                            "bestRating": 5
                        }
                    }))
                })

                document.head.appendChild(script);
            }
        },
        removeSchemaMarkup() {
            if (checkDocument()) {
                const script = document.getElementById("schema-reviews-jsonld")
                if (script) {
                    script.remove()
                }
            }
        }
    },
    mounted() {
        this.insertSchemaMarkup()
    },
    beforeUnmount() {
        this.removeSchemaMarkup()
    },
};
</script>

<template>
    <div>
        <div class="container mb-5">
            <h2 class="text-2xl font-semibold text-left">
                Отзывы компании
            </h2>
        </div>
        <div class="md:container ms-5">
            <Swiper :slides-per-view="1.2"
                    :space-between="10"
                    @swiper="setSwiper"
                    :loop="true"
                    :breakpoints="slider_breakpoints"
                    class="mb-8 w-full">
                <SwiperSlide v-for="(feedback, index) in text_feedbacks" :key="index">
                    <FeedbackBlock :link="feedback.link" :text="feedback.text" :name="feedback.name"
                                   :date="feedback.date_formatted" class="min-h-[255px] md:min-h-[255px]"/>
                </SwiperSlide>
            </Swiper>
            <div class="flex items-end justify-between max-md:me-5 mt-5">
                <div class="flex gap-3 max-md:hidden">
                    <button v-if="swiper" @click.prevent="slidePrev" aria-label="Назад"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5"/>
                    </button>
                    <button v-if="swiper" @click.prevent="slideNext" aria-label="Вперед"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5 rotate-180"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
